import { HttpHandler } from '../HttpHandler';
import { environment } from '../../enviroments';
import { CreateSpecialistReviewData, UpdateSpecialistReviewData } from '../../redux/specialistReviews/types';
import { SpecialistReview } from '@mindly/ui-components';

export const createSpecialistReview = async (data: CreateSpecialistReviewData) => {
  const { data: createdReviewData } = await HttpHandler({
    method: 'POST',
    url: `${environment.SPECIALIST_URL}/reviews`,
    data: data,
  });

  return createdReviewData.data;
};

export const updateSpecialistReview = async (data: UpdateSpecialistReviewData) => {
  const { data: updatedReviewData } = await HttpHandler({
    method: 'PATCH',
    url: `${environment.SPECIALIST_URL}/reviews/${data.id}`,
    data: {
      review_rating: data.starsCount,
      text_of_review: data.textOfReview,
    },
  });

  return updatedReviewData.data;
};

export const getApprovedSpecialistReviews = async (
  specialistID: string,
  showEditableForClientId: string,
  limit: number,
  offset: number
): Promise<SpecialistReview[]> => {
  const { data: reviewsData } = await HttpHandler({
    method: 'GET',
    url: `${environment.SPECIALIST_APP_URL}/reviews?limit=${limit}&offset=${offset}&orderBy=created_at.desc&specialist_id=equal:${specialistID}&showEditableForClientId=${showEditableForClientId}`,
  });

  return reviewsData.data;
};

export const getRatedSpecialist = async (clientID: string): Promise<SpecialistReview[]> => {
  const { data: ratedSpecialistData } = await HttpHandler({
    method: 'GET',
    url: `${environment.SPECIALIST_URL}/reviews/client/${clientID}`,
  });

  return ratedSpecialistData.data;
};

export const getClientSpecialistsReviews = async (): Promise<SpecialistReview[]> => {
  const { data: clientReviewsData } = await HttpHandler({
    method: 'GET',
    url: `${environment.SPECIALIST_REVIEWS_URL}/specialist-reviews/client/all`,
  });

  return clientReviewsData.data;
};
